import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import { SwiperSlide } from "swiper/react";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import PageType from "components/molecules/PageType";
import RefundGuarantee from "components/molecules/RefundGuarantee";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import FinancialSlider from "components/organisms/FinancialSlider";
import HowItWorks from "components/organisms/HowItWorks";
import OffshoreCompanyRegistration from "components/organisms/OffshoreCompanyRegistration";
import PackagesNews from "components/organisms/PackagesNews";
import RequiredDocument from "components/organisms/RequiredDocument";
import StepSlider from "components/organisms/StepSlider";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";

const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const CompanyFormationCountry = ({ data, dataJson, ...props }) => {
  const { country } = dataJson;

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson.breadcrumbs}
        title={`${country} <br/>Company Formation`}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10",
          textColor: "banner-title-default-color",
        }}
        dataTrustpilot={{
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot,
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            wrapper={{
              className: "bbc-banner-image-country pb-[98px] lg:pb-0",
            }}
            src={`/assets/images/offshore/country/${dataJson.banner_image}`}
            className="w-full "
            width={dataJson.banner_image_width || 560}
            height={dataJson.banner_image_height || 456}
            priority={true}
            alt={dataJson.imageAlt}
          />
        }
        bgColor={"bg-bbc-country"}
      >
        <div className="hidden py-6 lg:block"></div>
      </Banner>
      <div className="absolute left-1/2 -translate-x-1/2 -translate-y-[74px] text-center lg:-translate-y-1/2">
        <PageType data={dataJson.dataPageType} />
      </div>
      <section className="mt-10 lg:mt-20">
        <OffshoreCompanyRegistration data={dataJson.dataRegistration} />
      </section>
      <Img
        src="/assets/images/wave/top-wave.png"
        width={1920}
        height={125}
        className="w-full"
        wrapper={{ className: "w-full" }}
        alt="Wave top"
      />
      <div className="bg-bbc-package">
        <div className="container ">
          {/* <Packages
            data={data?.dataPackage || []}
            dataStatic={dataJson.dataPackage}
            title={
              (country === "United Kingdom" ? "UK" : country) +
              " Company Formation Packages"
            }
          /> */}
          <PackagesNews
            data={data?.dataPackage || []}
            dataStatic={dataJson.dataPackage}
            title={`${
              country === "United Kingdom" ? "UK" : country
            } Company Formation Packages`}
            subFeeArr={props.subFeeArr}
          />
          {dataJson.openBusinessAccount && (
            <div className="row mt-10 justify-between">
              <div className="col-12 flex items-center lg:col-6">
                <div className="w-full text-center ">
                  <Img
                    src={
                      "/assets/images/offshore/company-formation/group_business-offshore-formation.png"
                    }
                    width={346}
                    height={297}
                    alt={dataJson.businessAccountImgAlt}
                    wrapper={{ className: "mb-6 lg:mb-10 flex justify-center" }}
                  />
                  <div className="text-2xl font-semibold leading-9 text-bbc-gray">
                    <div className="text-center lg:text-left">
                      Open a{" "}
                      <span className="lg:text-bbc-brand-600">
                        business account
                      </span>
                    </div>
                    <div className="ext-center lg:mt-4 lg:text-right">
                      for your
                      <span className="lg:text-bbc-brand-600">
                        {" "}
                        UK company{" "}
                      </span>
                      efficiently
                    </div>
                  </div>
                  <ButtonNew
                    othersClass="mt-6 lg:mt-10 "
                    onClick={async () => {
                      // eslint-disable-next-line no-undef
                      await Tawk_API.toggle();
                    }}
                  >
                    Talk To Us
                  </ButtonNew>
                </div>
              </div>
              <div className="col-12 mt-6 lg:col-5 lg:mt-0">
                <div className="shadow-bbc rounded-xl bg-white py-9 px-8">
                  <div className="mb-6 text-center">
                    <Img
                      src={"/assets/images/common/wise-circle.png"}
                      width={80}
                      height={80}
                      alt="wise"
                      wrapper={{ className: "inline-block mr-2" }}
                    />
                    <Img
                      src={"/assets/images/common/payoneer-circle.png"}
                      width={80}
                      height={80}
                      alt="payoneer"
                      wrapper={{ className: "inline-block ml-2" }}
                    />
                  </div>
                  <p className="mb-3">
                    For a business account, we have partnered with:
                  </p>
                  <ul className="mb-3 pl-5 text-bbc-brand-500">
                    <li className="list-disc font-medium underline">
                      <a
                        href="https://wise.com/partner/bbcincorp"
                        target={"_blank"}
                        rel="nofollow noopener noreferrer"
                      >
                        Wise
                      </a>
                    </li>
                    <li className="list-disc font-medium underline">
                      <a
                        href="https://tracking.payoneer.com/SH2qL"
                        target={"_blank"}
                        rel="nofollow noopener noreferrer"
                      >
                        Payoneer
                      </a>
                    </li>
                  </ul>
                  <p>
                    With their services, your UK company can easily receive and
                    transfer money internationally.
                  </p>
                  {[
                    "Multi-currency business account",
                    "Support 80+ countries all over the world",
                    "Fast transfer with low fees",
                    "Mobile app and available debit cards",
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="mt-2 flex items-start first:mt-0"
                    >
                      <span>
                        <FaCheckCircle
                          size={16}
                          className="mr-2 mt-1 text-bbc-brand-600"
                        />
                      </span>
                      <span
                        dangerouslySetInnerHTML={{ __html: item }}
                        className=""
                      ></span>
                    </div>
                  ))}
                  <p className="mt-3">
                    Incorporate your UK company with us! We offer free support
                    for your business account.
                  </p>
                </div>
              </div>
            </div>
          )}
          <RefundGuarantee className="mb-10 pt-6 lg:mb-20 lg:pt-10" />
          {dataJson.dataFinancial && (
            <GroupFinancial data={dataJson.dataFinancial} />
          )}
          {/* {dataJson.dataEbookDownload && (
            <EbookDownload
              title={dataJson.dataEbookDownload.title}
              imgSrc={dataJson.dataEbookDownload.imgSrc}
              imgLeftSrc={dataJson.dataEbookDownload.imgLeftSrc}
              triggerName={dataJson.dataEbookDownload.triggerName}
              apiLink={dataJson.dataEbookDownload.apiLink}
              contactFromId={dataJson.dataEbookDownload.contactFromId}
              hash={dataJson.dataEbookDownload.hash}
              url={dataJson.dataEbookDownload.url}
              wrapper={{ className: "mb-10 lg:mb-20" }}
            >
              <p className="mb-6 font-medium">
                Opening a business account is a crucial step to manage payments.
                Arm yourself with adequate knowledge to smoothen the
                registration and management.
              </p>
              <p className="mb-2 font-medium">Get our guide to learn:</p>
              <ul>
                {[
                  " Comparison between bank accounts and fintech accounts",
                  " Valuable tips on how to choose the best-suited account",
                  " Procedure checklist for how to get one",
                ].map((item, index) => (
                  <li key={index} className="mb-2 last:mb-0">
                    <CheckContent data={item} />
                  </li>
                ))}
              </ul>
            </EbookDownload>
          )} */}
        </div>
        <WhatMakeUsDifferent
          title="Bring your next business venture online"
          data={dataJson.dataWhatMakeUsDifferent}
          className="bg-wmud py-[60px]"
        />
        {dataJson.dataOpenBankAccount &&
          typeof dataJson.dataOpenBankAccount === "object" &&
          Object.keys(dataJson.dataOpenBankAccount).length > 0 && (
            <StepSlider
              data={dataJson.dataOpenBankAccount}
              imgAlt={dataJson.dataOpenBankAccount.alt}
            />
          )}
        <HowItWorks
          title={country}
          subTitle="Company Incorporation Process"
          data={dataJson.dataHowItWorks}
          className="py-10 lg:py-20"
        />
        <RequiredDocument
          title={dataJson.dataRequiredDocument.title || "Required Documents"}
          data={dataJson.dataRequiredDocument}
          sectionClassName="py-10 lg:py-20"
          backgroundImage="/assets/images/common/required-documents.png"
        />
      </div>
      <section className="relative">
        <div className=" absolute hidden h-1/2 w-full bg-bbc-package md:block"></div>
        <div className="container relative  z-10 pt-10 lg:pt-20">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
              country_id={dataJson.dataFormContact.country_id}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/bottom-wave.png"
          width={1920}
          height={140}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:m-auto">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description={dataJson.dataFaqs.description}
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

const GroupFinancial = ({ data }) => {
  const CardFinancial = ({ item }) => {
    return (
      <div className="flex h-full flex-col rounded-xl bg-white  shadow-[8px_18px_13px_rgba(152,152,152,0.04)]">
        <div
          className={"flex h-14 justify-center rounded-t-xl"}
          style={{ backgroundColor: item.bgColor }}
        >
          <Img
            className="h-full w-full overflow-hidden rounded object-none object-center
                        transition-all duration-700
                        group-hover:scale-110 group-hover:transform"
            {...item?.logo}
          />
        </div>
        <div className="flex grow flex-col justify-between p-6">
          <div>
            <p className="mb-4 text-[#677294]">{item.description}</p>
            <ul className="mb-4">
              {item.options.map((option, index) => (
                <li key={index} className="flex text-bbc-brand-600">
                  <span className="mr-3 inline-block">
                    <FaCheckCircle className="inline text-bbc-brand-600 " />
                  </span>
                  <span className="font-medium text-[#4255A5]">{option}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="text-center ">
            <a
              href={item.href}
              rel="dofollow"
              title="Explore features"
              className="text-bbc-brand-500"
            >
              {item?.name}
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mb-10 lg:mb-20">
      <div className="row mb-0 items-center justify-end lg:mb-10">
        <div className="col-12 mb-14 flex justify-center lg:col-6 lg:mb-0">
          <Img {...data?.logo} loading="lazy" />
        </div>
        <div className="col-12 mb-6 lg:col-5 lg:mb-0">
          <div className="relative rounded-lg bg-white p-10 drop-shadow-sm">
            <p className="mb-4 text-[#677294]">{data?.taxhub?.description}</p>
            <p className="text-[#4255A5]">{data?.taxhub?.exclusive}</p>
            <ul>
              {data?.taxhub?.options.map((option, index) => (
                <li key={index} className="flex text-[#4255A5]">
                  <span className="mr-3 inline-block">
                    <FaCheckCircle className="inline text-[#4255A5] " />
                  </span>
                  <span className="font-medium text-[#4255A5]">{option}</span>
                </li>
              ))}
            </ul>
            <div
              className="absolute left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full bg-white drop-shadow-md"
              style={{ top: "-2rem" }}
            >
              <Img alt="taxHub" {...data?.imageTaxHub} />
            </div>
          </div>
        </div>
      </div>
      {Array.isArray(data.cards) && (
        <LazyLoad
          placeholder={
            data.cards.length > 0 &&
            data.cards.map((item, index) => {
              return <CardFinancial key={index} item={item} />;
            })
          }
        >
          <FinancialSlider>
            {data.cards.length > 0 &&
              data.cards.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="col-3 !h-auto">
                    <CardFinancial item={item} />
                  </SwiperSlide>
                );
              })}
          </FinancialSlider>
        </LazyLoad>
      )}
    </div>
  );
};

export default CompanyFormationCountry;
